import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import colors, { PROJECT_AREA_LINE_COLOR } from '~/colors';
import type { Project } from '~/common/types';
import layerStore from '~/store2/layers';

interface ProjectLayerProps {
  geometry: Project['geometry'];
  circle?: GeoJSON.MultiPoint;
}

export default function ProjectLayer({ geometry, circle }: ProjectLayerProps) {
  const { projectLayer } = useSnapshot(layerStore);

  const circleLayer = useMemo(() => {
    if (!circle) return null;

    return (
      <Source
        id="project-center"
        type="geojson"
        data={{
          type: 'Feature',
          geometry: circle,
          properties: {},
        }}
      >
        <Layer
          id="p-center"
          type="circle"
          source="project-center"
          paint={{
            'circle-color': PROJECT_AREA_LINE_COLOR,
            'circle-radius': 5,
            'circle-stroke-color': colors.white,
            'circle-stroke-width': 2,
          }}
        />
      </Source>
    );
  }, [circle]);

  if (!projectLayer) {
    return null;
  }

  return (
    <>
      <Source
        id="project"
        type="geojson"
        data={{
          type: 'Feature',
          geometry: geometry,
          properties: {},
        }}
      >
        <Layer
          type="line"
          paint={{
            'line-width': 4,
            'line-color': PROJECT_AREA_LINE_COLOR,
            'line-dasharray': [3, 1],
            'line-emissive-strength': 1,
          }}
          layout={{
            visibility: 'visible',
          }}
        />
      </Source>

      {circleLayer}
    </>
  );
}
